// extracted by mini-css-extract-plugin
export default {"root":"cmp-CartTrigger__cartCounter__root"};